import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, CardContent, CardHeader, IconButton, Typography, useTheme, Chip } from '@mui/material';
import StyledCard from '@ui/pages/Home/components/FullHeightCard/StyledCard';
import { FilterAltOutlined, Check } from '@mui/icons-material';
import ResponsiveSearch from '@ui/components/common/ResponsiveSearch';
import { useTranslation } from 'react-i18next';
const PeopleCard = ({ variant = 'light', headerTypographyVariant = 'h6', icon, heading, children, bgPattern = false, onClick, haveHeader = true, showAction, actionNode, leftActionNode, height = '100%', sx, searchValue = '', onSearchChange, showSearch = false, showFilters = false, onFilterClick, disableShadow, disableBackground, disableBorders, cardHeaderPadding, cardContentContainersx }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (_jsxs(StyledCard, { customVariant: variant, disableShadow: disableShadow, disableBackground: disableBackground, disableBorders: disableBorders, sx: {
            display: 'flex',
            flexDirection: 'column',
            height: height ?? '100%',
            overflow: 'hidden',
            minWidth: '268px',
            borderRadius: theme.spacing(4),
            ...sx
        }, onClick: onClick, children: [haveHeader && (_jsx(CardHeader, { sx: { padding: cardHeaderPadding }, avatar: icon && icon, title: _jsx(Typography, { variant: headerTypographyVariant, color: variant === 'light' || variant === 'grey'
                        ? theme.palette.grey[900]
                        : theme.palette.common.white, fontWeight: 500, children: heading }), action: _jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        width: '100%',
                        justifyContent: 'flex-end'
                    }, children: [leftActionNode, showSearch && (_jsx(Box, { mr: 1, children: _jsx(ResponsiveSearch, { value: searchValue, onChange: onSearchChange || (() => { }), placeholder: t('common.search'), breakpoint: 'lg' }) })), showFilters && (_jsx(Chip, { icon: _jsx(Check, { sx: { fontSize: '16px' } }), label: 'Filters', onClick: onFilterClick, variant: 'outlined', size: 'small', sx: {
                                backgroundColor: theme.palette.background.neutral,
                                borderColor: theme.palette.grey[300],
                                color: theme.palette.grey[700],
                                '&:hover': {
                                    backgroundColor: theme.palette.grey[100]
                                },
                                '& .MuiChip-icon': {
                                    color: theme.palette.grey[500]
                                }
                            } })), (showAction || actionNode) &&
                            (actionNode ?? (_jsx(IconButton, { size: 'Xs', sx: {
                                    color: variant === 'light'
                                        ? theme.palette.action.active
                                        : theme.palette.grey[500],
                                    background: variant === 'blue'
                                        ? alpha(theme.palette.grey[800], 0.4)
                                        : theme.palette.background.neutral,
                                    backdropFilter: 'blur(40px)'
                                }, children: _jsx(FilterAltOutlined, { sx: { aspectRatio: '1 / 1', width: '13.5px' } }) })))] }) })), _jsx(CardContent, { sx: {
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    ...cardContentContainersx
                }, children: children })] }));
};
export default PeopleCard;
